import { render } from "./CreateOrderProductPage.vue?vue&type=template&id=60bce89b"
import script from "./CreateOrderProductPage.vue?vue&type=script&lang=js"
export * from "./CreateOrderProductPage.vue?vue&type=script&lang=js"

import "@/css/CreateItemPage.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__